import module from "../module";
import template from "./pdf-viewer.tmpl.html";
import permission from "../../../constants/permission";

import { Subject, interval, empty, from, groupBy, map, filter, debounce, takeUntil, concat } from "rxjs";

import "./pdf-page";
import "./pdf-page-annotation-layer";
import "./pdf-page-annotations";

module.component("ppmPdfViewer", {
  bindings: {
    documentId: "<",
    version: "<",
    hideAnnotations: "<"
  },
  controller,
  template
});

function controller($q, PdfService, ApiPdfService, PrincipalService) {
  "ngInject";

  const vm = this,
    annotationChange$ = new Subject(),
    annotationRemove$ = new Subject();

  let unloadPdf = _ => _,
    stopChangeUpdates = _ => _;

  vm.pages = [];
  vm.sortByDate = true;

  setupChangeUpdates();

  vm.handleCreateAnnotation = function(annotation) {
    if (!PrincipalService.isInRole(permission.Edit)) {
      console.error = "You don't have permission to create annotations.";
      return;
    }
    const page = vm.pages[annotation.page];
    page.annotations = page.annotations.concat(annotation);

    if (vm.sortByDate) {
      sortAnnotationsByDate(page.annotations);
    } else {
      sortAnnotationsByPosition(page.annotations);
    }

    ApiPdfService.createAnnotation(pdfId(), annotation).then(data => {
      annotation.id = data.annotationId;
      annotation.timestamp = data.timestamp;
    });
  };

  vm.handleUpdateAnnotation = function(annotation) {    
    if (!PrincipalService.isInRole(permission.Edit)) {
      console.error = "You don't have permission to update annotations.";
      return;
    }
    annotationChange$.next(annotation);
  };

  vm.handleRemoveAnnotation = function(annotation) {
    if (!PrincipalService.isInRole(permission.Edit)) {
      console.error = "You don't have permission to remove annotations.";
      return;
    }
    const page = vm.pages[annotation.page];
    page.annotations = page.annotations.filter(a => a.id !== annotation.id);

    ApiPdfService.removeAnnotation(pdfId(), annotation.id);

    annotationRemove$.next(annotation);
  };

  vm.handleFocusChange = function(annotation, focused) {
    annotation.active = focused;
  };

  vm.handleSortByDate = function() {
    vm.sortByDate = true;
    vm.pages.map(page => sortAnnotationsByDate(page.annotations));
  };

  vm.handleSortByPosition = function() {
    vm.sortByDate = false;
    vm.pages.map(page => sortAnnotationsByPosition(page.annotations));
  };

  vm.$onChanges = function() {
    if (vm.version == null) {
      return;
    }

    unloadPdf();

    vm.pages = [];

    const pdfPromise = ApiPdfService.getPdfArraybuffer(pdfId()).then(data =>
        PdfService.getDocument(data)
      ),
      annotationsPromise = ApiPdfService.getAnnotations(pdfId());

    $q.all([pdfPromise, annotationsPromise]).then(([pdf, annotations]) => {
      handlePdfLoaded(pdf, annotations);
    });
  };

  vm.$onDestroy = function() {
    stopChangeUpdates();
    unloadPdf();
  };

  function setupChangeUpdates() {
    const debounceInterval$ = interval(750);
    let lastUpdate$ = empty();

    const subscription = annotationChange$
      .pipe(
        groupBy(annotation => annotation.id),
        map(annotation$ =>
          annotation$.pipe(
            debounce(_ => concat(lastUpdate$, debounceInterval$)),
            takeUntil(
              annotationRemove$.pipe(filter(removedAnnotation => removedAnnotation.id === annotation$.key))
            ))
        )
      )
      .subscribe(annotation$ => {
        const childSubscription = annotation$.subscribe(annotation => {
          const updatePromise = ApiPdfService.updateAnnotation(pdfId(), annotation);

          lastUpdate$ = from(updatePromise).pipe(filter(_ => false));
        });

        subscription.add(childSubscription);
      });

    stopChangeUpdates = _ => subscription.unsubscribe();
  }

  function handlePdfLoaded(pdf, allAnnotations) {
    unloadPdf = _ => pdf.destroy();

    const pageCount = pdf.numPages,
      pagePromises = "."
        .repeat(pageCount)
        .split("")
        .map((_, index) => index + 1)
        .map(i => pdf.getPage(i));

    $q.all(pagePromises).then(
      pages =>
        (vm.pages = pages.map(page => {
          const annotations = allAnnotations.filter(a => a.page === page._pageIndex);
          if (vm.sortByDate) {
            sortAnnotationsByDate(annotations);
          } else {
            sortAnnotationsByPosition(annotations);
          }
          return { page, annotations };
        }))
    );
  }

  function sortAnnotationsByPosition(annotations) {
    annotations.sort((a1, a2) => a1.y - a2.y);
  }

  function sortAnnotationsByDate(annotations) {
    annotations.sort((a1, a2) => a1.timestamp - a2.timestamp);
  }

  function pdfId() {
    return {
      documentId: vm.documentId,
      version: vm.version
    };
  }
}
